import type { Action } from 'redux';
import { combineReducers } from 'redux';

import { ordersBasketWorkspaceMetaReducer } from './meta/meta.reducer';
import type { OrdersBasketWorkspaceState } from './ordersBasket.model';
import { ordersBasketWorkspaceTabContentReducer } from './tabContent/tabContent.reducer';

export const ordersBasketWorkspaceReducer = combineReducers<OrdersBasketWorkspaceState, Action>({
  tabContent: ordersBasketWorkspaceTabContentReducer,
  meta: ordersBasketWorkspaceMetaReducer,
});
